import { useRecoilValue } from "recoil";
import { PagePath } from "src/pages/product/details";
import { globalPartnerState } from "src/recoil/partners/atom";

export function useRedirectMain() {
  const globalPartner = useRecoilValue(globalPartnerState);

  const setLocalstorageUrl = () => {
    localStorage.setItem("redirectMain", PagePath.main.replace(":partnerId", String(globalPartner?.id)));
  };

  return { setLocalstorageUrl };
}
